import { render, staticRenderFns } from "./MaterialServerCard.vue?vue&type=template&id=bec1e4ee&"
import script from "./MaterialServerCard.vue?vue&type=script&lang=js&"
export * from "./MaterialServerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports